import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { NotificationBadgesDataObject } from 'models/service';

export const getNotificationsPanelCounts = async () =>
  apiClient.get<NotificationBadgesDataObject, ApiClientResponse<NotificationBadgesDataObject>>(
    routes.notifications.panelCounts,
  );
